import { Container } from '@mui/material';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactGA from 'react-ga';
import { useEffect } from 'react';
import { internalRoutes } from './activities/teacherVoice/routing/routing';
import NavBar from './activities/teacherVoice/components/navBar/NavBar.component';

const TRACKING_ID = 'UA-219203005-1';
ReactGA.initialize(TRACKING_ID);

const App = () => {
    useEffect(() => {
        ReactGA.pageview('Main Website');
    }, []);

    return (
        <Router>
            <NavBar />
            <Container
                disableGutters
                sx={{
                    width: '100vw',
                    minHeight: '85vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflowX: 'hidden',
                }}
                maxWidth={false}
                className="App"
            >
                <Switch>
                    {internalRoutes.map(({ path, component }) => {
                        return (
                            <Route
                                exact
                                key={path}
                                path={path}
                                component={component}
                            />
                        );
                    })}
                </Switch>
            </Container>
        </Router>
    );
};

export default App;
